<script lang="ts">
    import {currentLesson, currentText, statsData} from './store'
    import {getLessons,getStats} from './services'
    const select = async (item) =>{
        $currentText=item.content;
        $currentLesson=item.id;
        $statsData = await getStats($currentLesson)
    }
</script>

<div class="list">
{#await getLessons()}
    Loading..
{:then list}
    {#each list as item}
        <button on:click="{async()=>{await select(item)}}">{item.id}:{item.title}</button>
    {/each}
{/await}

</div>


<style>

</style>

